<template>
    <div class="news">
        <!--***************************************************************-->

        <!--***************************************************************-->
        <b-container class="position-relative">
            <div class="sticky-top py-2" style="background: aliceblue; top: 55px; z-index: 2;" >
                <h2 class="title mb-3">最新消息</h2>
                <b-nav class="d-flex flex-wrap news_tag">
                    <b-nav-item class="text-nowrap" @click="listClick('')" :active="Param.Search.keywords == ''">全部</b-nav-item>
                    <b-nav-item class="text-nowrap"
                        v-for="(i2, i1) in typeName2"
                        :key="i1"
                        @click="listClick(i2.Name)"
                        :active="Param.Search.keywords == encodeURI(i2.Name)"
                        >{{ i2.Name }}
                    </b-nav-item>
                </b-nav>
            </div>
            

            <!--***************************************************************-->
            <BTableV1 :TablePage="TablePage" :cell="['data']">
                <template #data="{row}">
                    <ul class="list-unstyled list news-list" style="margin-bottom:0px">
                        <li>
                            <b-link @click="_go('./NewsDetail?id=' + row.item.Id)">
                                <div class="mb-0 mr-4 d-flex justify-content-between" style="flex-direction: column;">
                                    <strong class="newsDate text-black-50">
                                        {{ row.item.Create | datefmt('YYYY-MM-DD')}}
                                    </strong>
                                    <div class="h-100 d-flex justify-content-between" style="flex-direction: column;">
                                        <h5 class="clamp-2">{{ IsNull(row.item.Title) }}</h5>
                                        <div class="d-flex align-item-center flex-wrap mt-2" style="gap: 0.48rem;">
                                            <span class="badge badge-danger" v-show="row.item.Mark">置頂</span>
                                            <span class="badge badge-primary">{{ row.item.Type }}</span>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <b-img
                                        v-if="row.item.Cover != ''"
                                        style="min-width: 150px;"
                                        alt="文章封面"
                                        :src="$store.state.WebSite + 'files/_news/' + row.item.Id + '/cover.png'"
                                    />
                                    <b-img v-else src="./asset/no-image.png" fluid></b-img>
                                </div>
                            </b-link>
                        </li>
                    </ul>
                </template>
            </BTableV1>
            <b-row>
                <b-col class="text-center mb-5 mt-3" cols="12" v-if="pageHeader.pageSize < pageHeader.totalCount">
                    <b-button pill variant="primary" class="px-5" @click="More()">載入更多消息</b-button>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
    import { apiDictionaryList, apiGetNewsList } from '@/api/API.js';
    import BTableV1 from '../components/BTableV1.vue';
    // import PageV1 from '../components/PageV1.vue';
    export default {
        name: 'news',
        components: {
            BTableV1,
            // PageV1,
        },
        data() {
            return {
                typeName: {
                    '1': '公告',
                    '2': '重要公告',
                    '3': '課程訊息',
                    '4': '推廣教育小組',
                    '5': '疫情公告',
                },
                typeName2: {},

                files: {},
                SelectIf: {
                    type: '',
                },

                TablePage: {
                    title: '',
                    class: 'tclass courses',
                    BT_style: { 'thead-class': 'd-none' },
                    PG_style: {
                        pills: true,
                        align: 'center',
                    },
                    itemsAll: [],
                    items: [],
                    id: 'Table1',
                    currentPage: 1,
                    // rows: 20,
                    // page: 10,
                    sortBy: '',
                    sortDesc: false,
                    sortDirection: 'asc',
                    filter: null,
                    filterOn: [],
                    fields: [{ key: 'data', label: '' }],
                },

                //
                Param: this.$store.state.Param,
                pageHeader: '',
            };
        },
        mounted() {
            this.Init();
        },
        methods: {
            Init() {
                apiDictionaryList({
                    Paging: {
                        pageNumber: 1,
                        pageSize: 9999,
                    },
                    Search: {
                        keywords: '',
                        category: 'news',
                        type: 'category',
                    },
                }).then((res) => {
                    console.log(res.data);
                    this.typeName2 = res.data;
                });
                this.GetList();
            },
            GetList() {
                apiGetNewsList(this.Param).then((res) => {
                    this.pageHeader = JSON.parse(res.headers['list-header']).Paging;
                    this.TablePage.items = res.data;
                });
            },
            listClick(item) {
                this.Param.Search.keywords = encodeURI(item);
                this.GetList();
            },
            More() {
                this.Param.Paging.pageSize = this.Param.Paging.pageSize + 10;
                this.GetList();
            },
        },
    };
</script>
<style lang="scss">
    .news-list {
        img {
            width: 180px;
            height: auto;
        }
    }

    .tclass tr td {
        border-top: 0px;
    }

    .tclass tr:last-child .item {
        border-bottom: 0px;
    }

    .tclass th,
    .tclass td {
        padding: 0px !important;
    }
</style>
